import { ActionReducerMapBuilder, createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  applyIfLatest,
  latestRequestInitialState,
  trackLatestRequests,
} from 'state/latestRequest';

import { LsKeys } from 'enums';
import {
  getDoctor,
  getDoctorFinances,
  getDoctors,
  getDoctorVisits,
} from 'state/thunks/doctorThunk/doctorThunk';
import { editFinance, getFinances } from 'state/thunks/financeThunk/financeThunk';
import {
  createNotification,
  getNotifications,
} from 'state/thunks/notificationThunk/notificationThunk';
import {
  editUser,
  getPatientVisits,
  getUser,
  getUsers,
} from 'state/thunks/userThunk/userThunk';

const initialState = {
  doctors: null,
  doctor: null,
  count: null,
  lastPage: null,
  page: null,
  user: null,
  isLoading: false,
  visits: [],
  finances: [],
  ...latestRequestInitialState,
};

/**
 * The filtered list read is guarded by `applyIfLatest`: a search string, a
 * status filter and a page all change it, so overlapping requests are routine
 * and the reducer must apply the newest REQUEST rather than the newest
 * response. See src/state/latestRequest.ts.
 */
const slice = createSlice({
  name: 'finance',
  initialState,
  reducers: {
    setLogOut: () => initialState,
  },
  extraReducers: (builder: ActionReducerMapBuilder<any>) => {
    builder
      .addCase(
        getFinances.fulfilled,
        applyIfLatest(getFinances, (state, payload: any) => {
        console.log('get doctor success');
        console.log(payload);
        console.log(payload.rows);
        state.finances = payload;
        }),
      )
      .addCase(getDoctorFinances.fulfilled, (state, action: PayloadAction<any>) => {
        console.log('get doctor finances success');
        console.log(action.payload);
        console.log(action.payload.rows);
        //state.finances = action.payload;
      })
      .addCase(editFinance.fulfilled, (state, action: PayloadAction<any>) => {
        state.finances = {
          ...state.finances,
          rows: state.finances.rows.map((el: any) => {
            return el.id === action.payload.id
              ? {
                  ...el,
                  paymentStatus: action.payload.paymentStatus,
                }
              : el;
          }),
        };
      })
      .addCase(getDoctor.fulfilled, (state, action: PayloadAction<any>) => {
        console.log('get user success');
        console.log(action.payload);
        console.log(action.payload.rows);
        state.doctor = action.payload;
      })
      .addCase(getDoctors.fulfilled, (state, action: PayloadAction<any>) => {
        console.log('get doctor success');
        console.log(action.payload);
        console.log(action.payload.rows);
        state.doctors = action.payload;
        state.count = action.payload.count;
        state.lastPage = action.payload.lastPage;
        state.page = action.payload.page;
      })
      .addCase(editUser.pending, (state, action: PayloadAction<any>) => {
        state.isLoading = true;
      })
      .addCase(editUser.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
      })
      .addCase(editUser.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
      })
      .addCase(getUsers.rejected, (state, action: PayloadAction<any>) => {
        //state.error = action.payload;
        //state.isLoading = false;
      });

    // Matchers must come after every addCase.
    trackLatestRequests(builder, [getFinances]);
  },
});

export const financeActions = slice.actions;

export const financeReducer = slice.reducer;
